import axios from '@/user/axios.js'
import { fileDownload } from '@/utils'

const moduleAnalysis = {
  namespaced: true,
  state: {
    limit: {},
    asins: [],
    analyses: []
  },
  getters: {},
  mutations: {
    SET_LIMIT (state, data) {
      state.limit = data
    },
    SET_ASINS (state, data) {
      state.asins = data
    },
    SET_ANALYSES (state, data) {
      state.analyses = data
    },
    ADD_ANALYSES (state, data) {
      state.analyses = [
        data,
        ...state.analyses
      ]
    }
  },
  actions: {
    getAnalysisLimit: (context) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      return new Promise((resolve, reject) => {
        axios.get(`/api/analysis/limit/${sellerId}`)
          .then(resp => {
            if (resp.data.success) {
              context.commit('SET_LIMIT', resp.data.data)
              resolve(resp)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    listAnalyses: (context) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      return new Promise((resolve, reject) => {
        axios.get(`/api/analysis/${sellerId}`)
          .then(resp => {
            if (resp.data.success) {
              context.commit('SET_ANALYSES', resp.data.data)
              resolve(resp)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    listAsins: (context) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      return new Promise((resolve, reject) => {
        axios.get(`/api/analysis/asins/${sellerId}`)
          .then(resp => {
            if (resp.data.success) {
              context.commit('SET_ASINS', resp.data.data)
              resolve(resp)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    addAnalysis (context, payload) {
      const sellerId = context.rootState.account.activeAccount.sellerId
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post(`/api/analysis/asin/${sellerId}`, payload)
          context.commit('ADD_ANALYSES', res.data.data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getProduct: (context, payload) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      const id = payload.id
      return new Promise((resolve, reject) => {
        axios.get(`/api/analysis/product/${sellerId}/${id}`)
          .then(resp => {
            if (resp.data.success) {
              resolve(resp.data.data)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    updateFilter (context, payload) {
      const sellerId = context.rootState.account.activeAccount.sellerId
      const { id, ...data } = payload
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.put(`/api/analysis/filter/${sellerId}/${id}`, data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getReport: (context, payload) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      const id = payload.id
      return new Promise((resolve, reject) => {
        axios.get(`/api/analysis/report/${sellerId}/${id}`)
          .then(resp => {
            if (resp.data.success) {
              resolve(resp.data.data)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    downloadCSV (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        const { id, action } = payload
        try {
          const res = await axios.get(`/api/analysis/download/${sellerId}/${action}/${id}`, { responseType: 'blob' })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    downloadReportsCSV (context) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/analysis/reports/download/${sellerId}`, { responseType: 'blob' })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
     })
    }
  }
}

export default moduleAnalysis
